export const securoCryptoCurrencies = [
    {
        code: "SOL",
        name: "Solana",
        network: "solana",
        display_chain: "Solana chain",
    },
    {
        code: "USDC",
        name: "USDC",
        network: "solana",
        display_chain: "Solana chain",
    },
    {
        code: "USDT",
        name: "USDT",
        network: "solana",
        display_chain: "Solana chain",
    },
    {
        code: "USDT",
        name: "polygon_usdt",
        network: "polygon",
        display_chain: "Polygon chain",
    },
    {
        code: "USDC",
        name: "polygon_usdc",
        network: "polygon",
        display_chain: "Polygon chain",
    },
];
